/* eslint-disable react-hooks/rules-of-hooks */
// import React from 'react'
import React from "react";
import { Input, Button, Modal, ConfigProvider } from "antd";
import TableTemplete from "../../../components/table/TableTemplete";
import { getRedeemList, redeemVerify, buyGoods, sendGoods } from "./service";
import { openModal as openBuyModal } from "./component/buyModal";
import { openModal as openSendModal } from "./component/sendModal";
import styles from "./index.module.less";

const Redeem = () => {
  const [modalVisible, changeModalVisible] = React.useState(false);
  const [searchParams, changeSearchParams] = React.useState({});
  const tableTempleteRef = React.useRef();

  React.useEffect(() => {
    onSearch();
  }, []);

  const onSearch = () => {
    tableTempleteRef.current.onSearch(searchParams);
  };

  const handleVerify = (record) => {
    let msg = "正在进行核销操作，";
    if (record.isExpire !== "已过期" && record.winningLotteryType === 1) {
      msg = msg + "【实物】";
    }
    if (record.isExpire !== "已过期" && record.winningLotteryType === 2) {
      msg = msg + "【金币】";
    }
    if (record.isExpire === "已过期") {
      msg = msg + "特别提示，该兑换号码已过期，";
    }
    Modal.confirm({
      title: (
        <div>
          <span>操作提示</span>
          {record.isExpire === "已过期" && (
            <span style={{ color: "red" }}>(已过期)</span>
          )}
        </div>
      ),
      content: msg + "是否进行核销操作？",
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        const res = await redeemVerify({ id: record.id });
        if (res.code === 0) {
          onSearch();
          return Promise.resolve();
        }
        return Promise.reject();
      },
    });
  };
  // 购买
  const handleBuyGoods = (record) => {
    openBuyModal({ initData: { id: record.id } }).success(() => {
      onSearch();
    });
    // let msg = "正在进行购买操作，";
    // if (record.isExpire === "已过期") {
    //   msg = msg + "特别提示，该兑换号码已过期，";
    // }
    // Modal.confirm({
    //   title: (
    //     <div>
    //       <span>操作提示</span>
    //       {record.isExpire === "已过期" && (
    //         <span style={{ color: "red" }}>(已过期)</span>
    //       )}
    //     </div>
    //   ),
    //   content: msg + "是否进行购买操作？",
    //   okText: "确认",
    //   cancelText: "取消",
    //   onOk: async () => {
    //     const res = await buyGoods({ id: record.id });
    //     if (res.code === 0) {
    //       onSearch();
    //       return Promise.resolve();
    //     }
    //     return Promise.reject();
    //   },
    // });
  };
  // 发货
  const handleSendGoods = (record) => {
    openSendModal({ initData: { id: record.id } }).success(() => {
      onSearch();
    });
    // let msg = "正在进行发货操作，";
    // if (record.isExpire === "已过期") {
    //   msg = msg + "特别提示，该兑换号码已过期，";
    // }
    // Modal.confirm({
    //   title: (
    //     <div>
    //       <span>操作提示</span>
    //       {record.isExpire === "已过期" && (
    //         <span style={{ color: "red" }}>(已过期)</span>
    //       )}
    //     </div>
    //   ),
    //   content: msg + "是否进行发货操作？",
    //   okText: "确认",
    //   cancelText: "取消",
    //   onOk: async () => {
    //     const res = await sendGoods({ id: record.id });
    //     if (res.code === 0) {
    //       onSearch();
    //       return Promise.resolve();
    //     }
    //     return Promise.reject();
    //   },
    // });
  };

  return (
    <div className={styles.lotteryAction}>
      <div
        className={styles.action}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          {/* <Button type="primary" onClick={handleAdd}>
            新增
          </Button> */}
        </div>
        <Input.Search
          style={{ width: 260 }}
          placeholder="输入核销码"
          value={searchParams.keyWord}
          onChange={(e) => {
            changeSearchParams({ ...searchParams, keyWord: e.target.value });
          }}
          onSearch={onSearch}
        />
      </div>
      <TableTemplete
        setColumns={(columns) => {
          console.log("columns", columns);
          const newColumns = columns.map((ele) => {
            let newEle = { ...ele };
            if (newEle.dataIndex === "nickName") {
              newEle = {
                ...ele,
                render: (text, record) => {
                  return (
                    <span style={record.role === 0 ? { color: "red" } : {}}>
                      {text}
                    </span>
                  );
                },
              };
            }
            return newEle;
          });
          return newColumns;
        }}
        tableRef={tableTempleteRef}
        searchService={getRedeemList}
        tableProps={{
          style: { marginTop: 8 },
          rowKey: "id",
          // scroll: {
          //   x: 1200,
          //   y: 600
          // }
        }}
        operateColumn={{
          title: "操作",
          width: 180,
          render: (text, record) => {
            return [
              record.hasRedeemVerify === 1 && (
                <a
                  onClick={handleVerify.bind(this, record)}
                  className="action-btn"
                >
                  核销
                </a>
              ),
              record.hasRedeemVerify === 2 &&
                record.winningLotteryType === 1 && (
                  <a
                    onClick={handleBuyGoods.bind(this, record)}
                    className="action-btn"
                  >
                    购买
                  </a>
                ),
              record.hasRedeemVerify === 3 &&
                record.winningLotteryType === 1 && (
                  <a
                    onClick={handleSendGoods.bind(this, record)}
                    className="action-btn"
                  >
                    发货
                  </a>
                ),
            ];
          },
        }}
        editColumn={{
          goodsCodeName: (text, record) => {
            return record.codes.map((item, index) => (
              <div key={item.goodsCode}>
                <a
                  onClick={handleDelCode.bind(this, {
                    ...record,
                    goodsCode: item.goodsCode,
                  })}
                >
                  删除
                </a>
                &nbsp;&nbsp;
                <span>{item.goodsCode}</span>
              </div>
            ));
          },
        }}
      />
    </div>
  );
};

export default Redeem;
